var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _g3, _path21, _path22, _path23, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransactionClosing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_1170)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1301 40.6875V26.5573C44.1301 26.0469 43.9583 25.5521 43.6353 25.1563L37.0051 17.0156L30.3749 25.1563C30.052 25.5521 29.8801 26.0469 29.8801 26.5573V40.5156",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 26.834L37.0052 28.6934",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0103 38.7285V40.5879",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0155 37.0931V37.1712C34.0155 38.0306 34.8436 38.7285 35.8748 38.7285L38.1509 38.7233C39.1769 38.7233 40.0102 38.0254 40.0102 37.166L40.005 35.2598C40.005 34.4004 39.1717 33.7025 38.1457 33.7077H35.8696C34.8436 33.7077 34.0103 33.0098 34.0103 32.1504V30.2441C34.0103 29.3848 34.8436 28.6869 35.8696 28.6869H38.1457C39.1717 28.6869 40.005 29.3796 40.005 30.2389",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3801 32.4277V28.5788",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9531 64.1191H64.3802V54.4316",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63013 58.5879V64.1191H10.5416",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6355 28.5775V34.1035",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_93_1170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 33
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0214844H74.0104V32.8861H0V0.0214844Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_93_1170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.7136 26.7307L37.9636 0.980697C37.3907 0.56403 36.6198 0.56403 36.0521 0.980697L1.29696 26.7307C0.583417 27.2568 0.427167 28.2672 0.958416 28.9859L2.86987 31.5849C3.39591 32.3036 4.40112 32.4547 5.11987 31.9286L36.0521 9.01195C36.6198 8.59008 37.3907 8.59008 37.9584 9.01195L68.8907 31.9286C69.6042 32.4599 70.6146 32.3036 71.1407 31.5849L73.0521 28.9859C73.5834 28.2672 73.4323 27.2568 72.7136 26.7307Z",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.052 12.1621V2.51105C53.052 2.03709 53.4374 1.65167 53.9114 1.65167H60.151C60.6249 1.65167 61.0103 2.03709 61.0103 2.51105V18.0527",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2186 38.9954L47.4426 43.6985C46.729 44.0527 45.9374 44.2089 45.1405 44.1464L37.7134 43.5631C37.1457 43.5214 36.578 43.6516 36.0884 43.9433L27.8541 48.8444C27.3853 49.1256 27.3228 49.7871 27.7395 50.1464L28.0624 50.4277C29.4582 51.6412 31.427 51.9225 33.0988 51.1464L37.4061 49.1516C37.7863 48.9746 38.2186 48.9798 38.5936 49.1621L50.0155 54.735C51.6509 55.5318 53.5832 55.4537 55.1509 54.5214L63.4582 49.5527",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2395 41.9381L30.3957 43.959",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7292 57.4525L49.3334 62.364C50.5366 63.14 52.1355 62.7911 52.9063 61.5879C53.6824 60.3796 53.3334 58.7754 52.1355 57.9994",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1199 62.7135L45.2084 66.6406C46.6199 67.5573 48.5053 67.0781 49.323 65.6042C50.0678 64.2604 49.6407 62.5625 48.3543 61.7344",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4167 67.7768L41.698 70.5476C42.922 71.3392 44.5574 70.959 45.3126 69.7038C46.0365 68.5007 45.672 66.9434 44.4949 66.183",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_93_1170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 68,
    width: 8,
    height: 6
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8438 68.5098H41.2656V73.9941H34.8438V68.5098Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_93_1170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5103 71.9472L37.1196 72.9889C38.0675 73.5982 39.3175 73.4211 40.0519 72.567C40.953 71.5201 40.7238 69.9159 39.5675 69.1711",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4323 59.4434L17.5834 64.032C16.5417 65.0164 14.9063 64.9643 13.9272 63.9226C12.948 62.881 12.9949 61.2403 14.0365 60.2559L19.0678 55.7559C20.1042 54.8341 21.698 54.9382 22.6094 55.9903C23.4792 57.0007 23.4011 58.5268 22.4323 59.4434Z",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4323 63.2294C17.3177 64.2814 17.2083 66.0262 18.1823 67.2137C19.2552 68.5106 21.1979 68.6356 22.4219 67.4742L28.026 62.2398C29.2239 61.12 29.2708 59.2346 28.1354 58.0575C27.0312 56.9116 25.224 56.8596 24.0573 57.9377L22.4323 59.4429",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0364 66.8901C22.0207 67.8537 21.953 69.4578 22.8801 70.5047C23.8489 71.5985 25.5259 71.6714 26.5832 70.6662L30.1405 67.2599C31.1561 66.286 31.1926 64.6662 30.2186 63.6401C29.2447 62.6193 27.6301 62.5828 26.6093 63.562",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_93_1170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 65,
    width: 9,
    height: 10
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 65.334H34.6667V74.0163H26.6667V65.334Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_93_1170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.427 68.922C27.427 69.8699 27.4947 71.4897 28.5676 72.349C29.4478 73.0574 30.7135 73.0053 31.5312 72.2293L32.5728 71.224C33.4582 70.3751 33.5103 68.9688 32.6874 68.0574C31.8333 67.1042 30.3645 67.047 29.4426 67.9324",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6094 56.1191L10.75 53.0358",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56771 51.9222L10.9219 37.068C11.3073 36.2868 12.2448 35.9639 13.026 36.3389L16.4114 37.9691C17.2083 38.3545 17.5364 39.318 17.1458 40.1097L9.79165 54.9691C9.40624 55.7451 8.46874 56.0733 7.68749 55.6931L4.30208 54.068C3.50521 53.6826 3.17708 52.7191 3.56771 51.9222Z",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33.9638C60.75 33.5523 61.6875 33.8075 62.125 34.5471L62.901 35.8596L69.1406 46.4169L69.8646 47.6408C70.3229 48.4169 70.0521 49.4169 69.2656 49.8492L66.3594 51.4533C65.6094 51.8648 64.6667 51.6044 64.2344 50.87L63.4531 49.5523L57.2188 38.995L56.4896 37.7711C56.0365 37.0002 56.3073 36.0002 57.0938 35.5679L60 33.9638Z",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_1170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionClosing);
export default __webpack_public_path__ + "static/media/TransactionClosing.68a39a7b8d5e3feacf03c86f99efe25d.svg";
export { ForwardRef as ReactComponent };